import { z } from 'zod';
import type {
  RecordInboundReceiptOfficialSettlementRequest,
  RecordInboundReceiptOfficialSettlementResponse,
} from './record-inbound-receipt-official-settlement.dto.js';
import { InboundReceiptDetailDtoSchema } from './inbound-receipts-shared.schema.js';
import { IsoDateSchema } from '../shipments/shipments-types.js';

const trimmedStringSchema = z.string().trim().min(1);

export const RecordInboundReceiptOfficialSettlementRequestSchema: z.ZodType<RecordInboundReceiptOfficialSettlementRequest> =
  z
    .object({
      companyId: z.uuid(),
      receiptId: z.uuid(),
      shippingReportNumber: trimmedStringSchema.nullable().optional(),
      receivedDate: IsoDateSchema,
      weightTicketNumber: trimmedStringSchema,
      receivedWeightLb: z.number().min(0),
      shrinkagePercent: z.number().min(0).nullable().optional(),
      reductionFactor: z.number().min(0).nullable().optional(),
      paymentWeightLb: z.number().min(0),
      refundValueCents: z.int().min(0),
      processingFeeCents: z.int().min(0),
      administrativeFeeCents: z.int().min(0),
      totalPaymentDueCents: z.int(),
      onHold: z.boolean().nullable().optional(),
    })
    .strict();

export const RecordInboundReceiptOfficialSettlementResponseSchema: z.ZodType<RecordInboundReceiptOfficialSettlementResponse> =
  z
    .object({
      receipt: InboundReceiptDetailDtoSchema,
    })
    .strict();
